let $grid = $('.posts-wrapper');
let $pagination = $('#postsPagination');
let masonryOptions = {
  itemSelector: '.grid-item',
  columnWidth: '.grid-sizer',
  percentPosition: true,
  transitionDuration: 0,
};

let pageSize = (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) ? 5 : 12;

export default {
  init() {

    $('.single-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 800,
      cssEase: 'ease-in-out',
      centerMode: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        },
      ]
    });

    $('.series-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 800,
      cssEase: 'ease-in-out',
      centerMode: true,
    });

    $('.event-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
    });

    setTimeout(() => {
      if (!navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
        var side_box_height = $('.section-u-main .side-box').height();
        $('.section-u-main .posts-grid-box').height(side_box_height);
  
        $('.section-u-main .posts-grid-box').mCustomScrollbar({
          autoDraggerLength: false,
        });
      }
    }, 1000);

    $('#pagination').hide();
    $('#notFound').hide();

    let category = '';

    let data = {
      'action'    : 'ili_blog_filter',
      'category'  : category,
    };

    $pagination.pagination({
      dataSource: function(done) {
        $.ajax({ // you can also use $.post here
          url : ili_blog_filter.ajaxurl, // AJAX handler
          data : data,
          type : 'POST',
          async: true,
          success : function( response ) {
            done(response);
          },
        })
      },
      showPrevious: false,
      showNext: false,
      pageSize: pageSize,
      callback: function(data, pagination) {
        if (pagination.totalNumber === 0) {
          $('#pagination').hide();
          $('#notFound').show();
        } else {
          $('#pagination').show();
        }
        $('#loading').hide();
        $('#postsGrid').html(data);
      },
      afterInit: function () {
        $grid.masonry(masonryOptions);
        $grid.imagesLoaded().progress( function() {
          $grid.masonry('layout');
        });
      },
      beforePageOnClick: function () {
        $grid.masonry('destroy');
        $('#pagination').hide();
        $('#notFound').hide();

        if (navigator.userAgent.match(/(iPod|iPhone|Android)/)) {
          $('html, body').animate({
            scrollTop: 1400
          }, 'slow');
        } else if (navigator.userAgent.match(/(iPad)/)) {
          $('html, body').animate({
            scrollTop: 1200
          }, 'slow');
        } else {
          let aTag = $('.posts-grid-box');
          $('html,body').animate({
            scrollTop: aTag.offset().top - 100
          },100, function() {
            $('html,body').clearQueue();
          });
        }
      },
      afterPaging: function () {
        $grid.masonry(masonryOptions);
        $grid.imagesLoaded().progress( function() {
          $grid.masonry('layout');
        });
      }
    });

  },
  finalize() {

    /**
     * For select option
     * @type {jQuery.fn.init|jQuery|HTMLElement}
     */

    let $postCategories = $('input[name="postCategories"]');

    $postCategories.click(function() {
      $('#loading').show();
      $('#pagination').hide();
      $('#notFound').hide();
      $grid.masonry('destroy');
      $pagination.pagination('destroy');
      $('#postsGrid').empty();

      let category = $(this).attr('id');

      let data = {
        'action'    : 'ili_blog_filter',
        'category'  : category,
      };

      $pagination.pagination({
        dataSource: function(done) {
          $.ajax({ // you can also use $.post here
            url : ili_blog_filter.ajaxurl, // AJAX handler
            data : data,
            type : 'POST',
            async: true,
            success : function( response ) {
              done(response);
            },
          })
        },
        showPrevious: false,
        showNext: false,
        pageSize: pageSize,
        callback: function(data, pagination) {
          if (pagination.totalNumber === 0) {
            $('#pagination').hide();
            $('#notFound').show();
          } else {
            $('#pagination').show();
          }
          $('#loading').hide();
          $('#postsGrid').html(data);
        },
        afterInit: function () {
          $grid.masonry(masonryOptions);
          $grid.imagesLoaded().progress( function() {
            $grid.masonry('layout');
          });
        },
        beforePageOnClick: function () {
          $grid.masonry('destroy');
          $('#pagination').hide();
          $('#notFound').hide();

          if (navigator.userAgent.match(/(iPod|iPhone|Android)/)) {
            $('html, body').animate({
              scrollTop: 1400
            }, 'slow');
          } else if (navigator.userAgent.match(/(iPad)/)) {
            $('html, body').animate({
              scrollTop: 1200
            }, 'slow');
          }  else {
            let aTag = $('.posts-grid-box');
            $('html,body').animate({
              scrollTop: aTag.offset().top - 100
            },100, function() {
              $('html,body').clearQueue();
            });
          }
        },
        afterPaging: function () {
          $grid.masonry(masonryOptions);
          $grid.imagesLoaded().progress( function() {
            $grid.masonry('layout');
          });
        }
      });

    });

    /**
     * For link options (mobile)
     */

    $('.post-categories-list a').click(function() {
      $('.post-categories-list a').removeClass('active');
      $(this).addClass('active');
      $('#loading').show();
      $('#pagination').hide();
      $('#notFound').hide();
      $grid.masonry('destroy');
      $pagination.pagination('destroy');
      $('#postsGrid').empty();

      let category = $(this).data('value');

      let data = {
        'action'    : 'ili_blog_filter',
        'category'  : category,
      };

      $pagination.pagination({
        dataSource: function(done) {
          $.ajax({ // you can also use $.post here
            url : ili_blog_filter.ajaxurl, // AJAX handler
            data : data,
            type : 'POST',
            async: true,
            success : function( response ) {
              done(response);
            },
          })
        },
        showPrevious: false,
        showNext: false,
        pageSize: pageSize,
        callback: function(data, pagination) {
          if (pagination.totalNumber === 0) {
            $('#pagination').hide();
            $('#notFound').show();
          } else {
            $('#pagination').show();
          }
          $('#loading').hide();
          $('#postsGrid').html(data);
        },
        afterInit: function () {
          $grid.masonry(masonryOptions);
          $grid.imagesLoaded().progress( function() {
            $grid.masonry('layout');
          });
        },
        beforePageOnClick: function () {
          $grid.masonry('destroy');
          $('#pagination').hide();
          $('#notFound').hide();

          if (navigator.userAgent.match(/(iPod|iPhone|iPad|Android)/)) {
            $('html, body').animate({
              scrollTop: 1700
            }, 'slow');
          } else {
            let aTag = $('.posts-grid-box');
            $('html,body').animate({
              scrollTop: aTag.offset().top - 100
            },100, function() {
              $('html,body').clearQueue();
            });
          }
        },
        afterPaging: function () {
          $grid.masonry(masonryOptions);
          $grid.imagesLoaded().progress( function() {
            $grid.masonry('layout');
          });
        }
      });

    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/u.js